import { useMutation } from "react-query";
import auditService from "../../services/auditService";

const useReplaceAuditPDF = () =>
    useMutation(auditService.replacePdfForAudit)

export default useReplaceAuditPDF;